import { Colors, Flex, Typography } from '@banhala/ui-kit';
import type {
  NavigationState,
  SceneRendererProps,
} from 'react-native-tab-view';
import { TabBar, TabBarItem } from 'react-native-tab-view';
import type { MyPersonalizationTabRoute } from '../../../constant/tab';

type MyPersonalizationTabBarProps = SceneRendererProps & {
  navigationState: NavigationState<MyPersonalizationTabRoute>;
  onTabClick?: (index: number) => void;
};

export const MyPersonalizationTabBar = ({
  onTabClick,
  ...props
}: MyPersonalizationTabBarProps) => {
  const { navigationState } = props;
  const currentRoute = navigationState.routes[navigationState.index];

  return (
    <Flex alignItems={'center'}>
      <TabBar
        {...props}
        onTabPress={({ route }) => {
          const nextIndex = navigationState.routes.indexOf(route);
          onTabClick?.(nextIndex);
        }}
        style={{
          height: 44,
          backgroundColor: Colors.bg_always_white,
          borderBottomWidth: 1,
          borderBottomColor: Colors.border_tertiary,
          elevation: 0,
          shadowOpacity: 0,
        }}
        scrollEnabled={false}
        renderTabBarItem={tabItemProps => {
          const render = tabItemProps.route.render;
          return (
            <TabBarItem
              {...tabItemProps}
              key={tabItemProps.route.key}
              activeColor={render.selected_color}
              inactiveColor={render.unselected_color}
              label={({ route, focused, color }) => (
                <Typography
                  numberOfLines={1}
                  type={focused ? 'subtitle1.5' : 'body1.5'}
                  rawColor={color}
                >
                  {route.name}
                </Typography>
              )}
            />
          );
        }}
        indicatorStyle={{
          height: 2,
          backgroundColor:
            currentRoute?.render.selected_color ?? Colors.content_primary,
        }}
      />
    </Flex>
  );
};
